module.exports = __webpack_public_path__ + "img/university.a5ee6b23.svg";